export const BASIC_URL = process.env.NODE_ENV === 'development' ? "http://localhost:4000/" : "https://manzilik.sa/"

const config = {
    API_URL: BASIC_URL,
    IMAGE_URL: BASIC_URL + "images/",
};

export default config;
